import axios from 'axios';

export type NewsletterAudience = 'purchasing' | 'sales';

export type Newsletter = {
  id: string,
  title: string,
  /** The campaign's preview text, or null when it only repeated the subject. */
  summary: string | null,
  sentAt: string,
  archiveUrl: string | null,
}

export const getNewsletters = async (audience: NewsletterAudience): Promise<Newsletter[]> => {
  const response = await axios.get('/api/updates/newsletters', { params: { audience } });
  return response.data;
}

export const getNewsletterContent = async (campaignId: string): Promise<string> => {
  const response = await axios.get(`/api/updates/newsletters/${campaignId}/content`);
  return response.data.html;
}

export type UnreadUpTo = Partial<Record<NewsletterAudience, string>>;

export type UpdatesAnnouncement = Pick<Newsletter, 'id' | 'title' | 'summary' | 'sentAt'> & {
  audience: NewsletterAudience,
};

export type UpdatesStatus = {
  unreadUpTo: UnreadUpTo,
  announcement: UpdatesAnnouncement | null,
};

export const NO_UPDATES: UpdatesStatus = { unreadUpTo: {}, announcement: null };

export const getUpdatesStatus = async (): Promise<UpdatesStatus> => {
  const { data } = await axios.get('/api/updates/status');
  return data?.unreadUpTo && typeof data.unreadUpTo === 'object' ? data : NO_UPDATES;
}

export const saveUpdatesRead = async (unreadUpTo: UnreadUpTo): Promise<void> => {
  await axios.put('/api/updates/read', { upTo: unreadUpTo });
}

export const saveUpdatesDismissed = async (unreadUpTo: UnreadUpTo): Promise<void> => {
  await axios.put('/api/updates/dismissed', { upTo: unreadUpTo });
}
